import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";

export const ObjectPropertyValueContainer = styled.div`
  border-bottom: 1px solid ${COLORS.secondary};
  padding: 16px 0;
`;
